// extracted by mini-css-extract-plugin
export default {"button":"customization-task-card-button_button__9uh6u","content":"customization-task-card-button_content__mFO4c"};